.grid {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.85rem;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 16rem), 1fr));
}

.card {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  height: 100%;
  padding: 1.15rem 1.25rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-elev);
  color: var(--text);
  text-decoration: none;
  transition: border-color 200ms ease, background-color 200ms ease, transform 200ms ease;
}

.card:hover {
  color: var(--text);
  border-color: var(--accent);
  background: var(--bg-elev-2);
  transform: translateY(-2px);
}

.icon {
  display: grid;
  place-items: center;
  flex: none;
  width: 2.4rem;
  height: 2.4rem;
  border-radius: var(--radius-sm);
  background: var(--accent-quiet);
  color: var(--accent);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.label {
  font-weight: 600;
  font-size: var(--step--1);
}

.handle {
  color: var(--text-faint);
  font-family: var(--font-mono);
  font-size: 0.75rem;
  /* Long email addresses should truncate, not blow out the grid. */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.arrow {
  flex: none;
  margin-left: auto;
  color: var(--text-faint);
  transition: transform 200ms ease, color 200ms ease;
}

.card:hover .arrow {
  color: var(--accent);
  transform: translate(2px, -2px);
}

/* --- Résumé panel --------------------------------------------------------- */

.resume {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  margin-top: 1.75rem;
  padding: 1.6rem 1.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background:
    linear-gradient(120deg, var(--accent-quiet), transparent 60%),
    var(--bg-elev);
}

.resumeTitle {
  font-size: var(--step-1);
  font-weight: 600;
  letter-spacing: -0.01em;
}

.resumeBlurb {
  margin-top: 0.3rem;
  color: var(--text-dim);
  font-size: var(--step--1);
}

.resumeLink {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.3rem;
  border: 1px solid var(--accent);
  border-radius: var(--radius-pill);
  background: var(--accent);
  color: var(--on-accent);
  font-size: var(--step--1);
  font-weight: 600;
  text-decoration: none;
  transition: background-color 150ms ease, transform 150ms ease;
}

.resumeLink:hover {
  color: var(--on-accent);
  background: var(--accent-strong);
  border-color: var(--accent-strong);
  transform: translateY(-2px);
}
